module.exports = __webpack_public_path__ + "static/icons/informaCorreo.a255c28.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/characters/informaCorreo.svg
// module id = mx88
// module chunks = 1